exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Feature{width:300px;font-size:17px;margin:20px;line-height:1.4em}.Feature strong{font-size:21px;font-weight:700}.Feature-Icon{fill:#1b1c1d!important;width:30px;height:30px;vertical-align:bottom;margin-right:5px}.Feature-ComingSoon{background:#009688;display:inline-block;padding:.01em .4em;border-radius:4px;color:#fff;font-size:.7em;vertical-align:bottom;margin:0 .4em 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/index/Feature.css
// module id = ./src/pages/index/Feature.css
// module chunks = 2345137460201621000 4798610687222769000 17463659626562118000